export const compareByDisabledAndLabel = (
  a: { disabled: boolean; label: string },
  b: { disabled: boolean; label: string }
) => {
  if (a.disabled && !b.disabled) return -1
  if (!a.disabled && b.disabled) return 1

  return a.label.localeCompare(b.label)
}

const FIX_TYPE_PRIORITY: Record<string, number> = {
  patch: 1,
  minor: 2,
  major: 3,
  rebuild: 4,
  replace: 5,
  remove: 6,
  unknown: 7
}

export const compareByFixType = (
  { fixType: a = "unknown" }: { fixType: string },
  { fixType: b = "unknown" }: { fixType: string },
  priority = FIX_TYPE_PRIORITY
) => {
  if (a === b) return 0

  return (priority[a] || 10) - (priority[b] || 10)
}
